// src/lib/labels.js
// Locale-aware UI labels — single source of truth so the same noun lands the
// same in every surface (tab bar, view heading, dialogs, etc.). Add new
// regions here, never inline a translation at a render site.

// Region table for the "Pottering" verb (admin batch 2 commit 6).
//   en-GB family + Ireland → "Pottering"
//   en-US / Canada         → "Puttering" (the US spelling/usage)
//   anything else          → "Pottering" (default British-English)
const POTTERING_BY_REGION = {
  GB: 'Pottering',
  IE: 'Pottering',
  AU: 'Pottering',
  NZ: 'Pottering',
  ZA: 'Pottering',
  US: 'Puttering',
  CA: 'Puttering',
};

/**
 * Resolve the localised "Pottering" label for a region.
 *
 * Returns the British-English default for any region not explicitly listed.
 * The caller decides whether to use this output or fall back to a non-
 * regionalised neutral term — see `getPotteringTabLabel` below.
 *
 * @param {string|null|undefined} region — ISO 3166-1 alpha-2 code (e.g. 'GB', 'US')
 *   or any falsy value. Case-insensitive.
 * @returns {string}
 */
export function getPotteringLabel(region) {
  if (!region || typeof region !== 'string') return 'Pottering';
  return POTTERING_BY_REGION[region.toUpperCase()] || 'Pottering';
}

/**
 * Resolve the label for the Activity / Pottering tab + heading. The
 * `nav.pottering` feature flag is the gate — when off, both surfaces fall
 * back to the neutral "Activity" word; when on, both render the locale-aware
 * label from `getPotteringLabel(region)`. Single source of truth so the tab
 * bar and the view heading can never drift apart.
 *
 * @param {boolean} flagOn — value of `publicFlags['nav.pottering']`
 * @param {string|null|undefined} region — value of `localStorage.tend:region`
 * @returns {string} 'Activity' | 'Pottering' | 'Puttering' | …
 */
export function getPotteringTabLabel(flagOn, region) {
  if (!flagOn) return 'Activity';
  return getPotteringLabel(region);
}
